// Amplify do not export their user TS types, so any required
/* eslint-disable @typescript-eslint/no-explicit-any */

import { CognitoGroups } from "../config/groups";
import { RedirectRoutes } from "../routes/redirectRoutes";
import * as url from "url";

const VALID_DOMAINS = ["idwalmarine.com", "localhost"];

const validateRedirectUrl = (redirectUrl: string) => {
    const redirectHostname = url.parse(redirectUrl).hostname;

    let domainValid = false;

    VALID_DOMAINS.forEach((domain: string) => {
        if (redirectHostname?.endsWith(domain)) {
            domainValid = true;
        }
    });

    return domainValid;
};

export const getRedirectParameter = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("redirect")) {
        const redirect = decodeURIComponent(
            window.location.search.split("?redirect=")[1]
        );

        if (validateRedirectUrl(redirect)) {
            return redirect.replace(/&amp;/g, "&");
        }
    }
    return null;
};

/**
 * If the user is logged in but no redirect has been provided
 * Redirect to the appropriate app based on their Cognito User Groups
 * @param redirectUrl
 */
export const redirect = (user: any, redirectUrl: string | null) => {
    let locationHref = "";

    if (redirectUrl && validateRedirectUrl(redirectUrl)) {
        locationHref = redirectUrl;
    } else {
        locationHref = getRouteForUserGroup(user);
    }

    if (locationHref) {
        window.location.href = locationHref;
    }
};

const getUserGroups = (user: any) => {
    if (user) {
        return user.getSignInUserSession()?.getIdToken().payload[
            "cognito:groups"
        ];
    }
};

const getRouteForUserGroup = (user: any) => {
    const userGroups = getUserGroups(user);
    if (userGroups) {
        if (userGroups.includes(CognitoGroups.ADMIN)) {
            return RedirectRoutes.AsimsAdmin;
        } else if (
            userGroups.includes(CognitoGroups.SURVEYOR) ||
            userGroups.includes(CognitoGroups.DOC_COLLECTION)
        ) {
            return RedirectRoutes.InspectionSurveyorPortal;
        } else if (
            userGroups.includes(CognitoGroups.FLEET_PREMIUM_USER) ||
            userGroups.includes(CognitoGroups.FLEET_TECHNICAL_MANAGER) ||
            userGroups.includes(CognitoGroups.FLEET_THIRD_PARTY) ||
            userGroups.includes(CognitoGroups.FLEET_USER)
        ) {
            return RedirectRoutes.IdPlatform;
        }
    }
    return RedirectRoutes.AsimsCustomer;
};
